// src/pages/Auth/ForgotPassword.js
import React, { useState } from "react";
import { Link } from "react-router-dom";
import api from "../../api/axiosConfig";
import "./Auth.css";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    setSuccess("");

    try {
      const response = await api.post("/change-password", {
        email: email
      });

      if (response.status === 200) {
        setSuccess("Reset link has been sent to your email/phone");
      } else {
        setError(response.data?.message || "Failed to send reset link");
      }
    } catch (err) {
      console.error("Forgot password error:", err);
      setError(
        err.response?.data?.message || 
        err.response?.data || 
        "Unable to process your request. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-left-panel">
        {/* Same left panel as login */}
        <div className="animated-background">
          <div className="floating-shapes">
            <div className="shape shape-1"></div>
            <div className="shape shape-2"></div>
            <div className="shape shape-3"></div>
            <div className="shape shape-4"></div>
          </div>
          <div className="brand-section">
            <h1 className="brand-title">Reset Password</h1>
            <p className="brand-subtitle">We'll help you get back into your account</p>
          </div>
        </div>
      </div>

      <div className="login-right-panel">
        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-header">
            <h2>Forgot Password?</h2>
            <p>Enter your email or phone number to reset your password</p>
          </div>

          {error && <div className="error-message">{error}</div>}
          {success && <div className="success-message">{success}</div>}

          <div className="form-group">
            <label htmlFor="email">Email or Phone Number</label>
            <div className="input-with-icon">
               <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4 4H20C21.1 4 22 4.9 22 6V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18V6C2 4.9 2.9 4 4 4Z" stroke="#0b1083" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M22 6L12 13L2 6" stroke="#0b1083" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
              <input
                id="email"
                type="text"
                placeholder="Enter your email or phone number"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
          </div>

          <button type="submit" disabled={loading} className="login-btn">
            {loading ? (
              <>
                <i className="fas fa-spinner fa-spin"></i>
                Sending Reset Link...
              </>
            ) : (
              "Send Reset Link"
            )}
          </button>

          <div className="form-footer">
            <Link to="/login" className="back-to-login">
              <i className="fas fa-arrow-left"></i>
              Back to Login
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
}